import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { connect } from 'react-redux';
import { compose } from 'redux';
import {
  CircularProgress, Box, Typography
} from '@mui/material';

import { login as loginAction } from '../actions/auth';
import notifSystem from '../notifSystem';
import { popupNewSession } from '../utils/manageCookies';

function GoogleCallback({ login }) {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const token = params.get('token');
    const newCookie = params.get('newCookie') === 'true';
    const error = params.get('error');

    if (error) {
      const errorMessages = {
        google_auth_failed: 'Échec de l\'authentification Google',
        authentication_failed: 'Authentification échouée',
        unauthorized_ip: 'Connexion depuis une IP non autorisée',
        server_error: 'Erreur serveur',
      };

      notifSystem.error(
        'Erreur de connexion',
        errorMessages[error] || 'Une erreur est survenue'
      );
      navigate('/login');
      return;
    }

    if (token) {
      try {
        if (newCookie) {
          popupNewSession();
        }

        // Dispatch login action with token
        login(token, false);

        // Force page reload to refresh user data from server
        window.location.href = '/';
      } catch (err) {
        notifSystem.error(
          'Erreur',
          'Impossible de traiter l\'authentification'
        );
        navigate('/login');
      }
    } else {
      notifSystem.error(
        'Erreur',
        'Token d\'authentification manquant'
      );
      navigate('/login');
    }
  }, [location, login, navigate]);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        backgroundColor: 'white',
      }}
    >
      <CircularProgress size={60} />
      <Typography variant="h6" sx={{ mt: 3 }}>
        Connexion en cours...
      </Typography>
    </Box>
  );
}

const mapDispatchToProps = dispatch => ({
  login: (token, isRemotely) => dispatch(loginAction(token, isRemotely)),
});

export default compose(
  connect(null, mapDispatchToProps)
)(GoogleCallback);
